import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CategoryConfigurationService } from '@rocksoft/settings-sdk';
import { concatMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  CategoryConfigurationInheritedApiActions,
  CategoryConfigurationInheritedResolverActions,
} from './category-configuration-inherited.actions';

@Injectable()
export class CategoryConfigurationInheritedEffects {
  private readonly actions = inject(Actions);
  private readonly categoryConfigurationService = inject(CategoryConfigurationService);

  private loadInheritedConfiguration(categoryId: string) {
    return safeMap(
      this.categoryConfigurationService.getInheritedCategoryConfiguration({ categoryId }),
      (configuration) => {
        return CategoryConfigurationInheritedApiActions.categoryConfigurationInheritedLoaded({
          configuration,
        });
      },
      (error) => {
        return CategoryConfigurationInheritedApiActions.categoryConfigurationInheritedLoadedError({
          error,
        });
      }
    );
  }

  categoryConfigurationInheritedResolverEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(CategoryConfigurationInheritedResolverActions.categoryConfigurationInheritedRequested),
      concatMap((action) => this.loadInheritedConfiguration(action.categoryId))
    );
  });

  categoryConfigurationInheritedApiEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(CategoryConfigurationInheritedApiActions.categoryConfigurationInheritedRequested),
      concatMap((action) => this.loadInheritedConfiguration(action.categoryId))
    );
  });
}
